import { render } from "./PppRtkSettingsForm.vue?vue&type=template&id=147830e4"
import script from "./PppRtkSettingsForm.vue?vue&type=script&lang=js"
export * from "./PppRtkSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__